const data = [
  {
    id: 1,
    title: "Mount Fuji",
    location: "Japan",
    googleMapsUrl: "https://goo.gl/maps/1Xtj3QzKnKs3z3y37",
    startDate: "12 Jun, 2021",
    endDate: "24 Jun, 2021",
    description: "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
    imageUrl: "https://images.unsplash.com/photo-1589308078059-be1415eab4c3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    imgAlt: "Mount Fuji"
  },
  {
    id: 2,
    title: "Tromsø",
    location: "Norway",
    googleMapsUrl: "https://goo.gl/maps/6MELfoSzFF7y5cAS6",
    startDate: "10 Sep, 2021",
    endDate: "30 Sep, 2021",
    description: "The capital of the Arctic, Tromsø, is located right in the middle of Northern Norway. If your bucket list includes northern lights, whale watching, midnight sun, and epic nature adventures, this is where you want to go.",
    imageUrl: "https://images.unsplash.com/photo-1531571065863-3f9e05cc1af2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80",
    imgAlt: "Tromsø's Northern Lights"
  },
  {
    id: 3,
    title: "Paro Village",
    location: "Bhutan",
    googleMapsUrl: "https://goo.gl/maps/SEU3D7Bg7F2qrXtM8",
    startDate: "17 Mar, 2022",
    endDate: "10 Apr, 2022",
    description: "Its peaceful serene beauty and clean air, surrounded by unlevelled mountains, lush green fields, and historical buildings make Paro one of the most popular destination in Bhutan.",
    imageUrl: "https://images.unsplash.com/photo-1596516112176-7a9603d246e1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    imgAlt: "A Village in Paro"
  },
];

export default data;